import { Inject, Injectable } from '@angular/core';

import { oase_config } from '../environments/environment';
import { WINDOW } from './window';

@Injectable()
export class APIConfigService {
	constructor(@Inject(WINDOW) private window: Window) {}

	getHostname(): string {
		return this.window.location.hostname;
	}

	SERVER_API_URL(): string {
		let url = null;
		switch (this.getHostname()) {
			// case "localhost": return "http://localhost:9091/";
			case 'localhost':
			case oase_config.restapi.dev.host:
				url = oase_config.restapi.dev.schema + '://' + oase_config.restapi.dev.host;
				break;
			case oase_config.restapi.prod.host:
			default:
				url = oase_config.restapi.prod.schema + '://' + oase_config.restapi.prod.host;
				break;
		}
		return url + '/';
	}

	REST_API_BASE(): string {
		let path = null;
		switch (this.getHostname()) {
			// case "localhost": return "http://localhost:9091/";
			case 'localhost':
			case oase_config.restapi.dev.host:
				path = oase_config.restapi.dev.path;
				break;
			case oase_config.restapi.prod.host:
			default:
				path = oase_config.restapi.prod.path;
				break;
		}
		return this.SERVER_API_URL() + path + '/';
	}
}
